import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Icon from "../Common/Icon";
import "./Icons.scss";

export default class Icons extends Component {
    render() {
        return <section className="main">
                <div className="Lmt10">
                    <Link to="/" className="btn btn-primary btn-large">
                        去首页
                    </Link>
                    <Link to="/demo" className="btn btn-default btn-large Lmt10">
                        去Demo
                    </Link>
                </div>
                <div className='pageIcons'>
                    <h1>icons</h1>
                    <Icon name="Solid-arrow" color="#f00" size={50/375*100+'vw'}/>
                    <table className="table">
                        <tbody>
                            <tr>
                                <th>属性</th>
                                <th>类型</th>
                                <th>描述</th>
                            </tr>
                            <tr>
                                <td>name</td>
                                <td>string</td>
                                <td>必填，图标名称</td>
                            </tr>
                            <tr>
                                <td>color</td>
                                <td>string</td>
                                <td>选填，颜色</td>
                            </tr>
                            <tr>
                                <td>size</td>
                                <td>string</td>
                                <td>选填，文字图标大小，'12px'、'50/375*100+"vw"'</td>
                            </tr>
                        </tbody>
                    </table>
                    <main>
                        <h4 className="Lmt20">箭头</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="Solid-arrow"/>
                                <p>Solid-arrow</p>
                            </li>
                            <li>
                                <Icon name="Solid-arrow2"/>
                                <p>Solid-arrow2</p>
                            </li>
                            <li>
                                <Icon name="sort"/>
                                <p>sort</p>
                            </li>
                            <li>
                                <Icon name="sort2"/>
                                <p>sort2</p>
                            </li>
                            <li>
                                <Icon name="back"/>
                                <p>back</p>
                            </li>
                            <li>
                                <Icon name="bold_jiantou"/>
                                <p>bold_jiantou</p>
                            </li>
                            <li>
                                <Icon name="down_jiantou"/>
                                <p>down_jiantou</p>
                            </li>
                            <li>
                                <Icon name="up_jiantou"/>
                                <p>up_jiantou</p>
                            </li>
                            <li>
                                <Icon name="up-arrow"/>
                                <p>up-arrow</p>
                            </li>
                            <li>
                                <Icon name="jiantou_up"/>
                                <p>jiantou_up</p>
                            </li>
                            <li>
                                <Icon name="in_jiantou"/>
                                <p>in_jiantou</p>
                            </li>
                            <li>
                                <Icon name="in_jiantou1"/>
                                <p>in_jiantou1</p>
                            </li>
                        </ul>
                        <h4 className="Lmt20">货币</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="fanxian"/>
                                <p>fanxian</p>
                            </li>
                            <li>
                                <Icon name="fanxian_solid"/>
                                <p>fanxian_solid</p>
                            </li>
                            <li>
                                <Icon name="zhifu"/>
                                <p>zhifu</p>
                            </li>
                            <li>
                                <Icon name="money"/>
                                <p>money</p>
                            </li>
                            <li>
                                <Icon name="fen_solid"/>
                                <p>fen_solid</p>
                            </li>
                            <li>
                                <Icon name="fen"/>
                                <p>fen</p>
                            </li>
                            <li>
                                <Icon name="jifen"/>
                                <p>jifen</p>
                            </li>
                        </ul>
                        <h4 className="Lmt20">位置</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="map"/>
                                <p>map</p>
                            </li>
                            <li>
                                <Icon name="map_solid"/>
                                <p>map_solid</p>
                            </li>
                            <li>
                                <Icon name="fujin"/>
                                <p>fujin</p>
                            </li>
                            <li>
                                <Icon name="dingweii"/>
                                <p>dingweii</p>
                            </li>
                            <li>
                                <Icon name="dingw"/>
                                <p>dingw</p>
                            </li>
                            <li>
                                <Icon name="fujin2"/>
                                <p>fujin2</p>
                            </li>
                            <li>
                                <Icon name="Location"/>
                                <p>Location</p>
                            </li>
                            <li>
                                <Icon name="Location1"/>
                                <p>Location1</p>
                            </li>
                        </ul>
                        <h4 className="Lmt20">提示</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="tishi2"/>
                                <p>tishi2</p>
                            </li>
                            <li>
                                <Icon name="del"/>
                                <p>del</p>
                            </li>
                            <li>
                                <Icon name="tishi3"/>
                                <p>tishi3</p>
                            </li>
                            <li>
                                <Icon name="tishi4"/>
                                <p>tishi4</p>
                            </li>
                            <li>
                                <Icon name="tishi5"/>
                                <p>tishi5</p>
                            </li>
                            <li>
                                <Icon name="tishi6"/>
                                <p>tishi6</p>
                            </li>
                            <li>
                                <Icon name="Selected"/>
                                <p>Selected</p>
                            </li>
                            <li>
                                <Icon name="ok"/>
                                <p>ok</p>
                            </li>
                            <li>
                                <Icon name="puls"/>
                                <p>puls</p>
                            </li>
                            <li>
                                <Icon name="tips"/>
                                <p>tips</p>
                            </li>
                            <li>
                                <Icon name="ask"/>
                                <p>ask</p>
                            </li>
                            <li>
                                <Icon name="Question"/>
                                <p>Question</p>
                            </li>
                            <li>
                                <Icon name="queren"/>
                                <p>queren</p>
                            </li>
                            <li>
                                <Icon name="fail"/>
                                <p>fail</p>
                            </li>
                            <li>
                                <Icon name="tishi3-kong"/>
                                <p>tishi3-kong</p>
                            </li>
                        </ul>
                        <h4 className="Lmt20">表单</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="in_ren"/>
                                <p>in_ren</p>
                            </li>
                            <li>
                                <Icon name="Password"/>
                                <p>Password</p>
                            </li>
                            <li>
                                <Icon name="Verification"/>
                                <p>Verification</p>
                            </li>
                            <li>
                                <Icon name="hongbao"/>
                                <p>hongbao</p>
                            </li>
                            <li>
                                <Icon name="mima1"/>
                                <p>mima1</p>
                            </li>
                            <li>
                                <Icon name="phone"/>
                                <p>phone</p>
                            </li>
                        </ul>
                        <h4 className="Lmt20">其他</h4>
                        <ul className="Lmt10">
                            <li>
                                <Icon name="edit"/>
                                <p>edit</p>
                            </li>
                            <li>
                                <Icon name="meeting"/>
                                <p>meeting</p>
                            </li>
                            <li>
                                <Icon name="xianshi"/>
                                <p>xianshi</p>
                            </li>
                            <li>
                                <Icon name="tuifang"/>
                                <p>tuifang</p>
                            </li>
                            <li>
                                <Icon name="in-changbaofang"/>
                                <p>in-changbaofang</p>
                            </li>
                            <li>
                                <Icon name="like"/>
                                <p>like</p>
                            </li>
                            <li>
                                <Icon name="like_solid"/>
                                <p>like_solid</p>
                            </li>
                            <li>
                                <Icon name="jia"/>
                                <p>jia</p>
                            </li>
                            <li>
                                <Icon name="jian"/>
                                <p>jian</p>
                            </li>
                            <li>
                                <Icon name="tea"/>
                                <p>tea(drink)</p>
                            </li>
                            <li>
                                <Icon name="life"/>
                                <p>life</p>
                            </li>
                            <li>
                                <Icon name="life_solid"/>
                                <p>life_solid</p>
                            </li>
                            <li>
                                <Icon name="card"/>
                                <p>card</p>
                            </li>
                            <li>
                                <Icon name="card_solid"/>
                                <p>card_solid</p>
                            </li>
                            <li>
                                <Icon name="creditcard"/>
                                <p>creditcard</p>
                            </li>
                            <li>
                                <Icon name="dingdan"/>
                                <p>dingdan</p>
                            </li>
                            <li>
                                <Icon name="dingdan_solid"/>
                                <p>dingdan_solid</p>
                            </li>
                            <li>
                                <Icon name="in_dingdan"/>
                                <p>in_dingdan</p>
                            </li>
                            <li>
                                <Icon name="gouwu_solid"/>
                                <p>gouwu_solid</p>
                            </li>
                            <li>
                                <Icon name="hotels"/>
                                <p>hotels</p>
                            </li>
                            <li>
                                <Icon name="hotels_solid"/>
                                <p>hotels_solid</p>
                            </li>
                            <li>
                                <Icon name="jianshen1"/>
                                <p>jianshen1(exercise)</p>
                            </li>
                            <li>
                                <Icon name="jianshen_solid"/>
                                <p>jianshen_solid</p>
                            </li>
                            <li>
                                <Icon name="leren"/>
                                <p>leren(lady)</p>
                            </li>
                            <li>
                                <Icon name="leren_solid"/>
                                <p>leren_solid</p>
                            </li>
                            <li>
                                <Icon name="Mail-list"/>
                                <p>Mail-list</p>
                            </li>
                            <li>
                                <Icon name="mail"/>
                                <p>mail</p>
                            </li>
                            <li>
                                <Icon name="mail_solid"/>
                                <p>mail_solid</p>
                            </li>
                            <li>
                                <Icon name="qianbao"/>
                                <p>qianbao</p>
                            </li>
                            <li>
                                <Icon name="qianbao_solid"/>
                                <p>qianbao_solid</p>
                            </li>
                            <li>
                                <Icon name="screen_solid"/>
                                <p>screen_solid</p>
                            </li>
                            <li>
                                <Icon name="screen"/>
                                <p>screen</p>
                            </li>
                            <li>
                                <Icon name="shengji-1"/>
                                <p>shengji-1</p>
                            </li>
                            <li>
                                <Icon name="shengji_solid"/>
                                <p>shengji_solid</p>
                            </li>
                            <li>
                                <Icon name="tel"/>
                                <p>tel</p>
                            </li>
                            <li>
                                <Icon name="tel_solid"/>
                                <p>tel_solid</p>
                            </li>
                            <li>
                                <Icon name="tel1"/>
                                <p>tel1</p>
                            </li>
                            <li>
                                <Icon name="tequan"/>
                                <p>tequan</p>
                            </li>
                            <li>
                                <Icon name="tequan_solid"/>
                                <p>tequan_solid</p>
                            </li>
                            <li>
                                <Icon name="yule"/>
                                <p>yule(sing)</p>
                            </li>
                            <li>
                                <Icon name="yule_solid"/>
                                <p>yule_solid</p>
                            </li>
                            <li>
                                <Icon name="zuitijia"/>
                                <p>zuitijia</p>
                            </li>
                            <li>
                                <Icon name="zuitijia_solid"/>
                                <p>zuitijia_solid</p>
                            </li>
                            <li>
                                <Icon name="baoliu"/>
                                <p>baoliu</p>
                            </li>
                            <li>
                                <Icon name="Magnifier"/>
                                <p>Magnifier</p>
                            </li>
                            <li>
                                <Icon name="big_Magnifier"/>
                                <p>big_Magnifier</p>
                            </li>
                            <li>
                                <Icon name="city"/>
                                <p>city</p>
                            </li>
                            <li>
                                <Icon name="dianping"/>
                                <p>dianping</p>
                            </li>
                            <li>
                                <Icon name="Dustbin"/>
                                <p>Dustbin</p>
                            </li>
                            <li>
                                <Icon name="zaohui"/>
                                <p>zaohui</p>
                            </li>
                            <li>
                                <Icon name="gouwu"/>
                                <p>gouwu(shop)</p>
                            </li>
                            <li>
                                <Icon name="in_7zhe"/>
                                <p>in_7zhe</p>
                            </li>
                            <li>
                                <Icon name="Parking"/>
                                <p>Parking(service5)</p>
                            </li>
                            <li>
                                <Icon name="pic"/>
                                <p>pic</p>
                            </li>
                            <li>
                                <Icon name="bei"/>
                                <p>bei</p>
                            </li>
                            <li>
                                <Icon name="Shuttle"/>
                                <p>Shuttle</p>
                            </li>
                            <li>
                                <Icon name="SignOut"/>
                                <p>SignOut</p>
                            </li>
                            <li>
                                <Icon name="Stars"/>
                                <p>Stars</p>
                            </li>
                            <li>
                                <Icon name="triangle"/>
                                <p>triangle</p>
                            </li>
                            <li>
                                <Icon name="goodwifi"/>
                                <p>goodwifi</p>
                            </li>
                            <li>
                                <Icon name="wifi"/>
                                <p>wifi(service9)</p>
                            </li>
                            <li>
                                <Icon name="youhui"/>
                                <p>youhui</p>
                            </li>
                            <li>
                                <Icon name="zaocan"/>
                                <p>zaocan(food)(service8)</p>
                            </li>
                            <li>
                                <Icon name="zizhu"/>
                                <p>zizhu</p>
                            </li>
                            <li>
                                <Icon name="baibaoxiang"/>
                                <p>baibaoxiang(service79)</p>
                            </li>
                            <li>
                                <Icon name="bingxiang"/>
                                <p>bingxiang</p>
                            </li>
                            <li>
                                <Icon name="dayinji"/>
                                <p>dayinji</p>
                            </li>
                            <li>
                                <Icon name="rili"/>
                                <p>rili</p>
                            </li>
                            <li>
                                <Icon name="yuding"/>
                                <p>yuding</p>
                            </li>
                            <li>
                                <Icon name="yundou"/>
                                <p>yundou</p>
                            </li>
                            <li>
                                <Icon name="zaocan1"/>
                                <p>zaocan1</p>
                            </li>
                            <li>
                                <Icon name="zizhuxuanfang"/>
                                <p>zizhuxuanfang</p>
                            </li>
                            <li>
                                <Icon name="liwu"/>
                                <p>liwu</p>
                            </li>
                            <li>
                                <Icon name="liwu-solid-01"/>
                                <p>liwu-solid-01</p>
                            </li>
                            <li>
                                <Icon name="wen"/>
                                <p>wen</p>
                            </li>
                            <li>
                                <Icon name="wen-solid-01"/>
                                <p>wen-solid-01</p>
                            </li>
                            <li>
                                <Icon name="5zhe"/>
                                <p>5zhe</p>
                            </li>
                            <li>
                                <Icon name="jieji"/>
                                <p>jieji</p>
                            </li>
                            <li>
                                <Icon name="myufu"/>
                                <p>myufu</p>
                            </li>
                            <li>
                                <Icon name="pijiu"/>
                                <p>pijiu</p>
                            </li>
                            <li>
                                <Icon name="xuyuan"/>
                                <p>xuyuan</p>
                            </li>
                            <li>
                                <Icon name="zhentou"/>
                                <p>zhentou</p>
                            </li>
                            <li>
                                <Icon name="shengji"/>
                                <p>shengji</p>
                            </li>
                        </ul>
                    </main>
                </div>
            </section>;
    }
}





// WEBPACK FOOTER //
// ./src/components/Icons/Icons.js